import { useState } from 'react';

import { AccordionWithHeading } from '../../../components/general';
import { type Veranstaltung } from '../../../dtos';
import { content } from './TerminAblaufCard.content';
import { TerminAblaufEditCard } from './TerminAblaufEditCard';
import { TerminAblaufViewCard } from './TerminAblaufViewCard';

type TerminAblaufCardProps = {
  readonly veranstaltung: Veranstaltung;
  readonly isTerminreihe: boolean;
};

export const TerminAblaufCard = ({ veranstaltung, isTerminreihe }: TerminAblaufCardProps) => {
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <AccordionWithHeading heading={content.HEADING}>
      {!isEditMode && <TerminAblaufViewCard veranstaltung={veranstaltung} enableEditMode={() => setIsEditMode(true)} />}
      {isEditMode && (
        <TerminAblaufEditCard
          veranstaltung={veranstaltung}
          isTerminreihe={isTerminreihe}
          endEdit={() => setIsEditMode(false)}
        />
      )}
    </AccordionWithHeading>
  );
};
